// extracted by mini-css-extract-plugin
export default {"Header":"header_Header__1mrdG","Text":"header_Text__YIWpx","Icon":"header_Icon__b+kP9"};